<template>
  <div class="tab-pane active" id="form-step-3">
    <div class="row" v-if="!actions.showMobileVerification && !showCallback">
      <div class="col-sm-12">
        <h4 class="info-text">Where do you live?</h4>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Country</label><br />
          <vue-select
            class="vue-select"
            name="country"
            :options="countries"
            :class="{ error: errors.has('step3.country') }"
            label="CountryName"
            v-model="country"
            data-vv-scope="step3"
            v-validate="'required'"
            autocomplete="none"
            autofocus
          >
            <template slot="selected-option" slot-scope="option">
              <div class="flex">
                <div class="long-and-truncated-with-child-corrected">
                  <span>{{ option.CountryName }}</span>
                </div>
              </div>
            </template>
            <template slot="option" slot-scope="option">
              <span
                class="flag-icon flag-icon-squared"
                :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
              ></span
              >&nbsp;
              {{ option.CountryName }}
            </template>
          </vue-select>
        </div>
      </div>
      <div class="col-sm-6" v-show="this.isUKAddress">
        <div class="form-group">
          <label class="form-label required">Post Code</label>
          <input
            id="postcode"
            name="postcode"
            type="text"
            class="form-control"
            placeholder="Post Code"
            required
            v-model.trim="postCode"
            :class="{ error: errors.has('step3.postcode') }"
            data-vv-scope="step3"
            v-validate="'required'"
            autocomplete="none"
          />
        </div>
      </div>
      <div class="col-sm-6" v-show="!this.isUKAddress">
        <div class="form-group">
          <label class="form-label required">Post Code</label>
          <input
            id="pcOther"
            name="pcOther"
            type="text"
            class="form-control"
            placeholder="Post Code"
            required
            v-model.trim="postCode"
            :class="{ error: errors.has('step3.postcode') }"
            data-vv-scope="step3"
            v-validate="'required'"
            autocomplete="none"
          />
        </div>
      </div>

      <div class="col-sm-6 " v-if="this.isUKAddress">
        <div class="form-group">
          <label class="form-label required">Building Number/Name</label>
          <input
            id="buildingNo"
            name="buildingNo"
            type="text"
            class="form-control"
            placeholder="Building Number"
            required
            v-model.trim="buildingNo"
            :class="{ error: errors.has('step3.buildingNo') }"
            data-vv-scope="step3"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="col-sm-6 " v-else>
        <div class="form-group">
          <label class="form-label">Building Number/Name</label>
          <input
            id="building"
            type="text"
            class="form-control"
            placeholder="Building Number"
            v-model.trim="buildingNo"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required" v-if="this.isUKAddress == true"
            >Street</label
          ><label class="form-label required" v-else>Address</label>

          <input
            type="text"
            name="address"
            id="address"
            autocomplete="none"
            class="form-control"
            :placeholder="this.isUKAddress == true ? 'Street' : 'Address'"
            required
            v-model.trim="addressLine"
            :class="{ error: errors.has('step3.address') }"
            data-vv-scope="step3"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label>City</label>
          <input
            type="text"
            class="form-control"
            placeholder="City"
            v-model.trim="city"
            autocomplete="none"
          />
        </div>
      </div>
      <template v-if="this.isUKAddress == true">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">County</label>
            <input
              id="county"
              name="county"
              type="text"
              class="form-control"
              placeholder="County"
              v-model.trim="countyState"
              autocomplete="none"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">District</label>
            <input
              id="district"
              name="district"
              type="text"
              class="form-control"
              placeholder="District"
              v-model.trim="district"
              autocomplete="none"
            />
          </div>
        </div>
      </template>

      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required"
            >Date of birth (You must be 18+)</label
          >
          <input
            name="dob"
            class="form-control"
            type="tel"
            v-mask="'##/##/####'"
            placeholder="DD/MM/YYYY"
            required
            v-model.trim="dob"
            :class="{ error: errors.has('step3.dob') }"
            data-vv-scope="step3"
            v-validate="'required|date_format:dd/MM/yyyy|minage'"
          />
        </div>
      </div>

      <div class="col-sm-12 mt-3">
        <p>Do you need a joint account?</p>
        <div class="inputGroup">
          <input
            id="radio2"
            name="radio"
            type="radio"
            value="no"
            v-model="jointAccount"
          />
          &nbsp;<label for="radio2">No</label>
        </div>
        <div class="inputGroup">
          <input
            id="radio1"
            name="radio"
            type="radio"
            value="yes"
            v-model="jointAccount"
          />
          &nbsp;<label for="radio1">Yes</label>
        </div>
        <div v-if="jointAccount == 'yes'" class="row clearfix" key="additional">
          <div class="col-sm-12">
            <h4 class="info-text">Their details</h4>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label required">Title</label>
              <select
                name="titleAdditional"
                class="form-control custom-select"
                required
                v-model="titleAdditional"
                :class="{ error: errors.has('step3.titleAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
              >
                <option value="">Select...</option>
                <option value="48">Dr.</option>
                <option value="441">Lady</option>
                <option value="50">Lord</option>
                <option value="253">Miss.</option>
                <option value="46">Mr.</option>
                <option value="47">Mrs.</option>
                <option value="51">Ms</option>
                <option value="506">Other</option>
                <option value="122">Professor</option>
                <option value="49">Sir</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 ">
            <div class="form-group">
              <label class="form-label required">First Name</label>
              <input
                name="firstnameAdditional"
                type="text"
                class="form-control"
                placeholder="First Name"
                v-model.trim="firstNameAdditional"
                :class="{ error: errors.has('step3.firstnameAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
              />
              <!-- <label class="error" v-show="errors.has('step3.firstname')">This field is required.</label> -->
            </div>
          </div>
          <div class="col-sm-12 ">
            <div class="form-group">
              <label class="form-label required">Last Name</label>
              <input
                name="lastnameAdditional"
                type="text"
                class="form-control"
                :class="{ error: errors.has('step3.lastnameAdditional') }"
                placeholder="Last Name"
                v-model.trim="lastNameAdditional"
                data-vv-scope="step3"
                v-validate="'required'"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label class="form-label required">Email</label>
              <input
                name="emailAdditional"
                type="email"
                class="form-control"
                :class="{ error: errors.has('step3.emailAdditional') }"
                placeholder="Email Address"
                v-model.trim="emailAdditional"
                data-vv-scope="step3"
                v-validate="'required|email'"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label class="form-label required"
                >Date of birth (You must be 18+)</label
              >
              <input
                name="dobAdditional"
                class="form-control"
                type="tel"
                v-mask="'##/##/####'"
                placeholder="DD/MM/YYYY"
                required
                v-model.trim="dobAdditional"
                :class="{ error: errors.has('step3.dobAdditional') }"
                data-vv-scope="step3"
                v-validate="'required|date_format:dd/MM/yyyy|minage'"
              />
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <div class="form-group mt-3">
              <input
                type="checkbox"
                id="sameAddress"
                name="sameAddress"
                class=""
                required
                v-model="sameAddressAsMain"
              />&nbsp;
              <label for="sameAddress" class="sameAddress">
                &nbsp;Same address as main account?
              </label>
            </div>
          </div>
        </div>
        <div
          v-if="jointAccount == 'yes' && !sameAddressAsMain"
          class="row clearfix"
          key="additionalAddress"
        >
          <div class="col-sm-12">
            <div class="form-group">
              <label class="form-label required">Country</label><br />
              <vue-select
                class="vue-select"
                name="countryAdditional"
                :options="countries"
                :class="{ error: errors.has('step3.countryAdditional') }"
                label="CountryName"
                v-model="countryAdditional"
                data-vv-scope="step3"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CountryName }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  <span
                    class="flag-icon flag-icon-squared"
                    :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
                  ></span
                  >&nbsp;
                  {{ option.CountryName }}
                </template>
              </vue-select>
            </div>
          </div>
          <div class="col-sm-6" v-show="this.isUKAdditionalAddress">
            <div class="form-group">
              <label class="form-label required">Post Code</label>
              <input
                id="postcodeAdditional"
                name="postcodeAdditional"
                type="text"
                class="form-control"
                placeholder="Post Code"
                required
                v-model.trim="postCodeAdditional"
                :class="{ error: errors.has('step3.postcodeAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
                autocomplete="none"
              />
            </div>
          </div>

          <div class="col-sm-6" v-show="!this.isUKAdditionalAddress">
            <div class="form-group">
              <label class="form-label required">Post Code</label>
              <input
                id="pcOther2"
                name="pcOther2"
                type="text"
                class="form-control"
                placeholder="Post Code"
                required
                v-model.trim="postCodeAdditional"
                :class="{ error: errors.has('step3.postcodeAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
                autocomplete="none"
              />
            </div>
          </div>

          <div class="col-sm-6 " v-if="this.isUKAdditionalAddress">
            <div class="form-group">
              <label class="form-label required">Building Number/Name</label>
              <input
                name="buildingNoAdditional"
                type="text"
                class="form-control"
                placeholder="Building Number"
                required
                v-model.trim="buildingNoAdditional"
                :class="{ error: errors.has('step3.buildingNoAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
              />
            </div>
          </div>
          <div class="col-sm-6 " v-else>
            <div class="form-group">
              <label>Building Number/Name</label>
              <input
                name="buildingnumberAdditional"
                type="text"
                class="form-control"
                placeholder="Building Number"
                v-model.trim="buildingNoAdditional"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label
                class="form-label required"
                v-if="this.isUKAdditionalAddress == true"
                >Street</label
              ><label class="form-label required" v-else>Address</label>

              <input
                type="text"
                name="addressAdditional"
                id="addressAdditional"
                autocomplete="none"
                autofocus
                class="form-control"
                :placeholder="
                  this.isUKAdditionalAddress == true ? 'Street' : 'Address'
                "
                required
                v-model.trim="addressLineAdditional"
                :class="{ error: errors.has('step3.addressAdditional') }"
                data-vv-scope="step3"
                v-validate="'required'"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label>City</label>
              <input
                type="text"
                class="form-control"
                placeholder="City"
                v-model.trim="cityAdditional"
                autocomplete="none"
              />
            </div>
          </div>
          <template v-if="this.isUKAdditionalAddress == true">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">County</label>
                <input
                  id="countyStateAdditional"
                  name="countyStateAdditional"
                  type="text"
                  class="form-control"
                  placeholder="County"
                  v-model.trim="countyStateAdditional"
                  autocomplete="none"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">District</label>
                <input
                  id="districtAdditional"
                  name="districtAdditional"
                  type="text"
                  class="form-control"
                  placeholder="District"
                  v-model.trim="districtAdditional"
                  autocomplete="none"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <div class="form-group mt-3">
          <input
            type="checkbox"
            id="terms"
            name="terms"
            class=""
            required
            v-model="terms"
          />&nbsp;
          <label for="terms" class="terms">
            I have read and agree to the &nbsp;
            <a
              href="https://www.smartcurrencyexchange.com/legal/terms-and-conditions/"
              target="_blank"
              >Terms and Conditions</a
            >.
          </label>
        </div>
      </div>
    </div>
    <verify-code v-else-if="actions.showMobileVerification && !showAntiSpam" />
    <Callback v-else-if="showAntiSpam && showCallback" />
  </div>
</template>
<script>
const options = {
  key: process.env.VUE_APP_LOQ_KEY,
  countries: { codesList: "GBR" },
};
let control;
let controlAdditional;
import VerifyCode from "@/components/verification/VerifyCode.vue";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Callback from "@/components/steps/Callback.vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "flag-icon-css/css/flag-icon.min.css";
export default {
  name: "Address",
  computed: {
    ...mapFields([
      "form.addressLine",
      "form.postCode",
      "form.buildingNo",
      "form.city",
      "form.country",
      "form.postcodeAnywhereId",
      "form.street",
      "form.district",
      "form.countyState",
      "form.useDetails",
      "form.telPrefix",
      "form.telephone",
      "form.dob",
      "form.titleAdditional",
      "form.firstNameAdditional",
      "form.lastNameAdditional",
      "form.emailAdditional",
      "form.addressLineAdditional",
      "form.postCodeAdditional",
      "form.buildingNoAdditional",
      "form.cityAdditional",
      "form.countryAdditional",
      "form.postcodeAnywhereIdAdditional",
      "form.streetAdditional",
      "form.districtAdditional",
      "form.countyStateAdditional",
      "form.useDetailsAdditional",
      "form.mobilePrefixAdditional",
      "form.mobileAdditional",
      "form.dobAdditional",
      "form.terms",
      "form.jointAccount",
      "form.sameAddressAsMain",
    ]),
    ...mapGetters({
      actions: "getActions",
      countryCodes: "getCountryCodes",
      countries: "getCountries",
       showAntiSpam:"getAntiSpam",
      showCallback:"getCallback"
    }),
    isUKAddress() {
      return this.country.CountryId && this.country.CountryId == 225;
    },
    isUKAdditionalAddress() {
      return (
        this.countryAdditional.CountryId &&
        this.countryAdditional.CountryId == 225
      );
    },
  },
  components: {
    "verify-code": VerifyCode,
    "vue-select": VueSelect,
      Callback,
  },
  directives: { mask },
  watch: {
    sameAddressAsMain: function() {
      if (!this.sameAddressAsMain) this.initAddressLookupAdditionalUser();
    },
    country: function() {
      if (this.isUKAddress) {
        control.reload();
      } else control.destroy();
    },
    countryAdditional: function() {
      if (this.isUKAdditionalAddress) {
        controlAdditional.reload();
      } else controlAdditional.destroy();
    },
  },
  methods: {
    initAddressLookup() {
      var self = this;

      //main user
      const fields = [{ element: "postcode", field: "PostalCode" }];
      control = new pca.Address(fields, options);

      control.listen("populate", function(address, variations) {
        self.populated(address, variations);
      });
      setTimeout(() => {
        $("#address").attr("autocomplete", "none");
        $("#postcode").attr("autocomplete", "none");
      }, 1000);
    },
    initAddressLookupAdditionalUser() {
      var self = this;

      //additional user
      setTimeout(() => {
        const fieldsAdditional = [
          { element: "postcodeAdditional", field: "PostalCode" },
        ];
        controlAdditional = new pca.Address(fieldsAdditional, options);

        controlAdditional.listen("populate", function(address, variations) {
          self.populatedAdditional(address, variations);
        });

        $("#addressAdditional").attr("autocomplete", "none");
        $("#postcodeAdditional").attr("autocomplete", "none");
      }, 1000);
    },
    populated(address) {
      if (this.isUKAddress) {
        this.postcodeAnywhereId = address.Id;
        this.addressLine = address.Street;
        this.postCode = address.PostalCode;
        this.city = address.City;
        this.district = address.District;
        this.countyState = address.AdminAreaName;
        this.buildingNo =
          address.BuildingNumber != ""
            ? address.BuildingNumber
            : address.BuildingName;
      } else {
        this.addressLine = address.FormattedLine1;
        this.postCode = address.PostalCode;
        this.city = address.City;
        this.buildingNo =
          address.BuildingNumber != ""
            ? address.BuildingNumber
            : address.BuildingName;
      }
      //set country too
      // this.country = {
      //   CountryId: 225,
      //   CountryName: "UNITED KINGDOM",
      //   ShowOnSite: true,
      //   TwoCharCode: "GB",
      // };
    },
    populatedAdditional(address) {
      if (this.isUKAdditionalAddress) {
        this.postcodeAnywhereIdAdditional = address.Id;
        this.addressLineAdditional = address.Street;
        this.postCodeAdditional = address.PostalCode;
        this.cityAdditional = address.City;
        this.districtAdditional = address.District;
        this.countyStateAdditional = address.AdminAreaName;
        this.buildingNoAdditional =
          address.BuildingNumber != ""
            ? address.BuildingNumber
            : address.BuildingName;
      } else {
        this.addressLineAdditional = address.FormattedLine1;
        this.postCodeAdditional = address.PostalCode;
        this.cityAdditional = address.City;
        this.buildingNoAdditional =
          address.BuildingNumber != ""
            ? address.BuildingNumber
            : address.BuildingName;
      }

      //set country too
      // this.countryAdditional = {
      //   CountryId: 225,
      //   CountryName: "UNITED KINGDOM",
      //   ShowOnSite: true,
      //   TwoCharCode: "GB",
      // };
    },
  },
  created() {},
  mounted() {
    /* global pca */
    this.initAddressLookup();
  },
};
</script>
